import { render, staticRenderFns } from "./AfterSalesReview.vue?vue&type=template&id=ebaf3650&scoped=true"
import script from "./AfterSalesReview.vue?vue&type=script&lang=js"
export * from "./AfterSalesReview.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesReview.vue?vue&type=style&index=0&id=ebaf3650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaf3650",
  null
  
)

export default component.exports